export const deMessages = {
  companyLogo: {
    Binance: 'Binance Firmenlogo',
    Bitpanda: 'Bitpanda Firmenlogo',
    Coinbase: 'Coinbase Firmenlogo',
  },
  icon: {
    check: 'Erfolgshäkchen',
  },
  iFrame: {
    title: {
      bank: 'Referenzüberweisung Dateneingabe',
      idnow: 'IDnow Video-Identifizierung',
    },
    announcement: {
      bank: 'Referenzüberweisung Frame geladen',
      idnow: 'IDnow Video-Identifizierung Frame geladen',
    },
  },
  accessibilityStatement: {
    button: 'Erklärung zur Barrierefreiheit',
    modalLabel: 'Modal Erklärung zur Barrierefreiheit',
    intro: {
      title: 'Erklärung zur Barrierefreiheit für Solaris SE',
      paragraph1: 'Diese Erklärung gilt für alle Inhalte auf der Domain:',
      paragraph2: 'Diese Website wird von Solaris SE betrieben.',
      paragraph3:
        'Sie ist so gestaltet, dass sie für möglichst viele Leute zugänglich ist, auch für Menschen mit Behinderungen.',
      paragraph4:
        'Wir arbeiten daran, die Benutzerfreundlichkeit für alle zu verbessern und relevante Standards für Barrierefreiheit einzuhalten, um die Nutzbarkeit und Inklusivität zu verbessern.',
    },
    commitment: {
      title: 'Unser Engagement',
      paragraph1:
        'Diese Website wurde so gestaltet, dass sie den {link} (WCAG) 2.1, Stufe AA entspricht.',
      paragraph2:
        'Diese Richtlinien beschreiben die besten Vorgehensweisen, um unseren Service für Menschen mit einer Vielzahl von Behinderungen zugänglich zu machen, darunter Seh-, Hör-, Körper-, Sprach-, kognitive, Lern- und neurologische Behinderungen.',
    },
    features: {
      title: 'Barrierefreiheit',
      paragraph1:
        'Um die Barrierefreiheit zu unterstützen, haben wir die folgenden Funktionen implementiert:',
      listItem1: 'Die Textgröße kann um bis zu 200% vergrößert werden.',
      listItem2: 'Wichtige Bilder haben alternative Textbeschreibungen.',
      listItem3:
        'Interaktiven Elemente können über die Tastatur bedient werden.',
      listItem4: 'Ausreichender Farbkontrast is gewährleistet.',
      listItem5: 'Das Layout ist logisch und responsiv.',
    },
    compatibility: {
      title: 'Kompatibilität mit Browsern und assistiver Technologie',
      paragraph1:
        'Diese Website wurde mit der folgenden Kombination aus Browsern und assistiver Technologie getestet:',
      browsers: '<strong>Browser:</strong> Google Chrome.',
      assistiveTech: '<strong>Assistive Technologie:</strong> VoiceOver.',
    },
    limitations: {
      title: 'Bekannte Einschränkungen',
      paragraph1:
        'Trotz unserer Bemühungen, die Barrierefreiheit dieser Website sicherzustellen, sind uns einige Einschränkungen bekannt. Nachfolgend finden Sie eine Beschreibung dieser Einschränkungen:',
      listItem1:
        'Diese Website lädt Inhalte externer Anbieter (Identitätsdienste) in Frames. Wir arbeiten eng mit unseren Partnern zusammen, um Barrierefreiheit sicherzustellen, haben aber nur begrenzte Kontrolle über spätere Änderungen.',
    },
    contact: {
      title: 'Feedback & Kontakt',
      paragraph1:
        'Wir freuen uns über Ihr Feedback zur Barrierefreiheit unserer Website. Bitte informieren Sie uns, sollten Sie auf Barrieren stoßen.',
      paragraph2:
        'Unser Kundenservice bemüht sich, Anfragen schnellstmöglich zu bearbeiten.',
      contactForm: {
        title: 'Kontaktformular: ',
        cta: 'Schreiben Sie uns ',
        supplementary:
          '(bitte geben Sie im Formular keine sensiblen Daten an, z. B. persönliche Finanzdaten, Informationen zu Ihrer Gesundheit oder andere sensible Themen).',
      },
    },
    lastReview: {
      title: 'Datum der letzten Überprüfung',
      paragraph1:
        'Diese Erklärung wurde am 31.07.2025 überprüft und veröffentlicht.',
    },
  },
  announcer: {
    true: 'Inhalt lädt',
    false: 'Inhalt geladen',
    routeChanged: {
      universal_start: 'Neue Seite geladen. Inhalt: Startseite',
      video_ident_start:
        'Neue Seite geladen. Inhalt: Start Videoidentifizierung',
      video_ident_video: 'Neue Seite geladen. Inhalt: Videoidentifizierung',
      bank_ident_start: 'Neue Seite geladen. Inhalt: Start Referenzüberweisung',
      bank_ident_mobile_number:
        'Neue Seite geladen. Inhalt: Telefonnummerbestätigung',
      bank_ident_iban: 'Neue Seite geladen. Inhalt: IBAN-Angabe',
      bank_ident_document_signing:
        'Neue Seite geladen. Inhalt: Dokumentunterzeichnung',
    },
  },
  loadingSpinner: 'Ladestandsanzeiger',
  globalTitle: 'Verifizieren Sie Ihre Identität',
  progressBar: {
    steps: {
      phoneVerification: 'Rufnummer Verifizieren',
      bankIdentification: 'Referenzüberweisung',
      videoIdentification: 'Video-Identifizierung',
      signDocuments: 'Digital Signieren',
      current: 'Aktuell: ',
      next: 'Nächster Schritt: ',
      label: 'Schritt {index} von {length}',
    },
    label: 'Fortschrittsanzeige',
  },
  selectIdentificationMethod: {
    title: 'Identifikationsmethode auswählen',
    bankIdent: {
      heading: 'Über deutsches Bankkonto',
      description:
        'Loggen Sie sich bei Ihrer Bank ein, um eine Überweisung von 1 EUR zu bestätigen. Dieser Betrag wird automatisch zurückerstattet',
      hint: '(IBAN und Zugangsdaten erforderlich)',
      badge: 'Schneller',
    },
    videoEid: {
      heading: 'Über Video-Anruf',
      languageDescription:
        'Unterstützte Sprachen für Videoanrufe: Englisch, Französisch, Italienisch, Portugiesisch, Deutsch und Spanisch.',
    },
    otherMethod: 'Mit einer anderen Methode identifizieren',
  },
  skipToContent: 'Zum Hauptinhalt springen',
  startBankIdentification: {
    title: 'Über deutsches Bankkonto identifizieren',
    titleContinue: 'Identifikation fortführen',
    descriptionContinue: 'Bitte wählen Sie eine Identifikationsmethode aus.',
    step1: 'Telefonnummer bestätigen',
    step1Done: 'Telefonnummer bestätigt ({number})',
    bank: {
      step2:
        'Loggen Sie sich bei Ihrer Bank ein und bestätigen Sie eine Überweisung von 1 EUR. Der Betrag wird automatisch zurückerstattet.',
      step3: 'Angaben prüfen und bestätigen',
    },
  },
  startVideoIdentification: {
    title: 'Über Video-Anruf',
    description: {
      part1: 'Sie benötigen Ihren ',
      part2: 'Personalausweis oder Reisepass',
      part3: ' und Ihr Smartphone. ',
    },
  },
  phoneVerification: {
    title: 'Rufnummer bestätigen',
    description:
      'Bitte geben Sie die SMS-TAN ein, die Sie soeben auf folgender Telefonnummer erhalten haben: ',
    tanValidationError: {
      required: 'Die Eingabe der TAN ist erforderlich',
      invalidLength: 'Die TAN besteht aus genau 6 Ziffern',
      invalidFormat: 'Falsches TAN-Format',
    },
    success: {
      header: 'Rufnummer erfolgreich verifiziert!',
      descriptionBank: {
        part1: 'Für den nächsten Schritt halten Sie bitte Ihre ',
        part2: ' und ',
        part3: 'Anmeldedaten',
        part4: ' zu Ihrem Online-Banking bereit.',
      },
      descriptionVideo: {
        part1: 'Für den nächsten Schritt benötigen Sie Ihren ',
        part2: 'Personalausweis oder Reisepass',
        part3: ' und Ihr Smartphone.',
        part4:
          'Wenn Sie die eID-Funktion Ihres deutschen Personalausweises nutzen möchten, halten Sie bitte Ihre 6-stellige PIN bereit.',
      },
    },
  },
  tanInput: {
    label: 'TAN-Ziffer {index} eingeben',
  },
  tanRetry: {
    requestCodeIn: 'Einen neuen Code anfordern in',
    buttonSubmit: 'Neuen Code senden',
  },
  paymentInitiation: {
    title: 'Bitte geben Sie die IBAN ein',
    description: {
      part1: 'IBAN eines ',
      part2: 'deutschen Bankkontos',
      part3:
        ', das unter Ihrem Namen läuft. Gemeinschaftskonten können nicht verwendet werden.',
    },
    termsAndConditions: {
      checkboxName: 'Swisscom Allgemeinen Geschäftsbedingungen',
      label:
        'Ich habe die <a>Allgemeinen Geschäftsbedingungen</a> der Swisscom IT Service Finance S.E. gelesen und akzeptiert.',
      hint: 'Unser Dienstleister für rechtsverbindliche und sichere elektronische Unterschriften',
      required:
        'Sie müssen den Allgemeinen Geschäftsbedingungen zustimmen um fortzufahren',
    },
    ibanValidationError: {
      invalidIban: 'Ungültige IBAN angegeben',
    },
    buttonSubmit: 'Zu meinem Bank Login',
    buttonIdnow: 'Stattdessen Video-Identifizierung starten',
    error: {
      title: {
        matchForPersonDataNotFound:
          'Alternative Identifizierungsmethode erforderlich',
        personAccountMatchNotFound: 'Alternative IBAN erforderlich',
        generic: 'Die Identifikation ist leider fehlgeschlagen',
      },
      possibleNextStep: {
        generic: {
          retryable:
            '\nBitte versuchen Sie es mit einer anderen IBAN oder fahren Sie mit Video-Identifizierung fort.',
          generic:
            '\nBitte fahren Sie mit der Video-Identifizierung fort, um den Verifizierungsprozess abzuschließen.',
        },
        bankOnly: {
          retryable:
            '\nBitte geben Sie eine neue IBAN ein, um den Verifizierungsprozess fortzusetzen.',
          generic:
            '\nBitte fahren Sie mit einer anderen Methode fort, um den Verifizierungsprozess abzuschließen.',
        },
      },
      buttonRetry: 'Andere IBAN verwenden',
      buttonIdnowFallback: 'Zur Video-Identifizierung',
    },
  },
  paymentIntiationSuccessfull: {
    title: 'Referenzüberweisung erfolgreich',
    description:
      'Abschließend überprüfen und bestätigen Sie bitte Ihre persönlichen Angaben.',
  },
  videoIdentification: {
    mobile: {
      step1: 'Halten Sie Ihren Reisepass oder Personalausweis bereit.',
      step2: 'Kopieren Sie Ihre ID-Referenz unten.',
      step3: 'IDnow-App herunterladen und Code zum Starten einfügen.',
      info: 'Je nach Auslastung der Videoidentifikations-Experten kann es zu Wartezeiten kommen.',
      copyButton: {
        info: 'Kopieren Sie Ihren Referenz:',
        label: 'Copy ID: {identificationReference}',
        success: 'Kopiert!',
      },
      download: {
        title: 'Laden Sie die IDnow-App herunter',
      },
      googlePlayBadge: 'Jetzt bei Google Play',
      iosAppStoreBadge: 'Laden im Apple App Store',
    },
    successful: {
      title: 'Identifikation erfolgreich!',
      description:
        'Klicken Sie auf Fertig stellen, um die Identifizierung abzuschließen.',
      automaticRedirect: 'Oder Sie werden automatisch weitergeleitet in',
    },
  },
  signDocuments: {
    initial: {
      title: 'Herunterladen und überprüfen',
      description: 'Bitte überprüfen Sie die Informationen in den Dokumenten.',
    },
    enterTan: {
      title: 'Persönliche Daten bestätigen',
      description:
        'Bitte geben Sie die SMS-TAN ein, die Sie soeben auf folgender Telefonnummer erhalten haben: ',
      transactionId: 'Ihre Transaktions-ID lautet: ',
      transactionInfo:
        'Vergewissern Sie sich, dass die Transaktions-ID mit den Daten in der SMS übereinstimmt.',
    },
    successful: {
      title: 'Identifikation erfolgreich!',
      description: {
        coinbase:
          'Ihre Identität wurde erfolgreich verifiziert. Sie und Coinbase sind jetzt an die Nutzungsvereinbarung, der Sie bei der Einrichtung Ihres Coinbase-Kontos zugestimmt haben, gebunden.',
        default:
          'Bitte stellen Sie sicher, dass Sie das Dokument heruntergeladen haben.',
      },
    },
    viewDocument: 'Identifizierungsbericht anzeigen',
  },
  identificationLoading: {
    initializing: 'Lädt …',
    connecting: 'Eine sichere Verbindung zu Ihrer Bank wird hergestellt.',
    credentials: {
      part1: 'Bitte halten Sie Ihre ',
      part2: 'Online-Banking-Zugangsdaten',
      part3: ' bereit. ',
    },
    processing: 'Informationen werden übermittelt …',
  },
  helpPopup: {
    linkTextPart1: 'Erfahren Sie mehr über den ',
    linkTextPart2: 'Identifizierungsprozess',
    text: 'Bei Fragen können Sie sich gern an unser Kundensupport-Team wenden:',
    teaserText: 'Sie haben Fragen? Wir helfen gern.',
    buttonName: 'Hilfe bekommen',
    popupLabel: 'Erweiterte Support-Infobox',
    supportPhoneLabel: 'Telefonnummer Kundensupport',
  },
  testLabel: 'testLabel',
  testInfo: 'testInfo',
  testValidationError: 'testValidationError',
  button: {
    cancel: 'Abbrechen',
    back: 'Zurück',
    confirm: 'Bestätigen',
    continue: 'Fortfahren',
    next: 'Weiter',
    start: 'Starten',
    finish: 'Fertig',
    skip: 'Überspringen',
  },
};
